import React from 'react'

import clsx from 'clsx'

import Compare from '../Compare'
import Save from '../Save'

import classes from './CompareSave.module.scss'

const CompareSave = ({ listing, className, onlySaveIcon, compareButtonProps, showSaveCount, ...props }) => {
  return (
    <div className={clsx('CompareSave', classes.root, className)} {...props}>
      <Compare listing={listing} useBasket variant="outlined" fullWidth={false} {...compareButtonProps} />
      <Save listing={listing} onlyIcon={onlySaveIcon} showSaveCount={showSaveCount} />
    </div>
  )
}

export default CompareSave
